import { useState } from "react";
import { Link } from "react-router-dom";
import { HomePageAssets } from "../assets/homePageIcons";
import { MUSICADE_EVENT_URL } from "../constants/apiUrls";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <nav className="fixed top-0 left-0 w-full md:max-w-[1640px] md:left-1/2 md:-translate-x-1/2 lg:max-w-none lg:left-0 lg:translate-x-0 2xl:left-1/2 2xl:-translate-x-1/2 flex justify-between items-center px-4 md:px-4 py-6 backdrop-blur z-50">
        <Link to="/">
          <img src={HomePageAssets.landscapeLogo} className="w-[7rem] md:w-[10rem] md:h-14" alt="Musicade Logo" />
        </Link>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6">
          <a
            href={MUSICADE_EVENT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-2 p-4 text-sm md:text-base border-2 border-transparent bg-clip-padding relative overflow-hidden transition  hover:scale-105   "

          >
            <span >Find Events</span>
            <span className="absolute inset-0 rounded-full" style={{
              background: 'linear-gradient(135deg, #ff6b35, #f7931e)',
              padding: '1px',
              WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude',
            }}></span>
          </a>
          <a
            data-umami-event="Download App Header"
            href="https://apps.apple.com/us/app/musicade/id6747211062?uo=4"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download App"
            className="px-5 py-2 p-4 text-sm md:text-base rounded-full bg-[#78267566] backdrop-blur-md hover:bg-purple-500/20 transition inline-flex items-center gap-2"
          >
            <span>Download</span>
            <img src={HomePageAssets.downloadIcon} className="w-4 h-4" alt="Download" />
          </a>
        </div>

        {/* Mobile Menu Button - Visible only on mobile */}
        <button 
          className="md:hidden text-white p-2 focus:outline-none"
          onClick={() => setIsMenuOpen(true)}
          aria-label="Open menu"
        >
            <div className="flex flex-col gap-1.5 items-end">
                <span className="block w-6 h-0.5 bg-white"></span>
                <span className="block w-4 h-0.5 bg-white"></span>
                <span className="block w-6 h-0.5 bg-white"></span>
            </div>
        </button>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-2xl flex flex-col justify-between">
            {/* Top Bar with Logo and Close Button */}
            <div className="flex justify-between items-center px-4 py-6 w-full">
                <Link to="/" onClick={() => setIsMenuOpen(false)}>
                    <img src={HomePageAssets.landscapeLogo} className="w-[7rem]" alt="Musicade Logo" />
                </Link>
                <button 
                    onClick={() => setIsMenuOpen(false)} 
                    className="text-white w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition backdrop-blur-md"
                    aria-label="Close menu"
                >
                    <i className="fas fa-times text-sm"></i>
                </button>
            </div>

            {/* Centered Content */}
            <div className="flex flex-col items-center justify-center gap-12 w-full px-6 flex-1 -mt-20">
                <a
                    href={MUSICADE_EVENT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-8 py-3 rounded-full text-white text-xl font-medium   border-2 border-transparent bg-clip-padding relative overflow-hidden transition  "

                    onClick={() => setIsMenuOpen(false)}
                >
                    <span className="relative z-10">Find Events</span>
                    <span className="absolute inset-0 rounded-full" style={{
                      background: 'linear-gradient(135deg, #ff6b35, #f7931e)',
                      padding: '2px',
                      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                      WebkitMaskComposite: 'xor',
                      maskComposite: 'exclude',
                    }}></span>
                </a>
                
                <a
                    data-umami-event="Download App Mobile Menu"
                    href="https://apps.apple.com/us/app/musicade/id6747211062?uo=4"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-10 py-3 rounded-full bg-[#592651] text-white text-lg font-medium flex items-center justify-center gap-3 transition min-w-[200px] shadow-lg"
                >
                    <span>Download</span>
                    <img src={HomePageAssets.downloadIcon} className="w-5 h-5" alt="" />
                </a>
            </div>
            
            {/* Spacer for bottom balance */}
            <div className="h-20"></div>
        </div>
      )}
    </>
  );
}
